import { Shield } from "lucide-react";

// Nome membro staff: testo olografico arcobaleno animato + scudetto.
// Usare al posto del nome semplice in ogni lista pubblica (classifica, roster, giveaway...).
export const StaffName = ({ name, className = "", iconClass = "w-3.5 h-3.5" }) => (
  <span className={`inline-flex items-center gap-1.5 ${className}`}>
    <Shield className={`staff-holo-icon ${iconClass}`} aria-label="Staff" />
    <span className="staff-holo">{name}</span>
  </span>
);

export default StaffName;
